import { BOOKING_URL, BRAND } from '@/constants';

export default function Hero() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="accueil"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#07271f]"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=serene%20wellness%20spa%20interior%20with%20warm%20amber%20candlelight%2C%20dark%20wooden%20massage%20table%2C%20traditional%20cupping%20glass%20cups%20arranged%20beautifully%2C%20soft%20linen%20textures%2C%20moroccan%20inspired%20decor%2C%20deep%20warm%20tones%2C%20cinematic%20moody%20atmosphere%2C%20professional%20photography&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt={`${BRAND.name} — cupping thérapie à ${BRAND.city}`}
          className="absolute inset-0 w-full h-full object-cover object-center animate-kenburns origin-center will-change-transform"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(to bottom, rgba(4,22,17,.68) 0%, rgba(4,22,17,.38) 45%, rgba(4,22,17,.78) 100%)',
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 90% 70% at 50% 45%, transparent 55%, rgba(2,14,10,.55) 100%)',
          }}
        />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col items-center text-center py-28 md:py-32">
        <span className="inline-flex items-center gap-2 border border-[#f2ede2]/30 text-[#a8dcc4] text-[11px] font-semibold tracking-[0.2em] uppercase px-5 py-2.5 rounded-full mb-8 backdrop-blur-sm">
          <i className="ri-map-pin-line"></i>
          Cupping thérapie · {BRAND.city} {BRAND.postalCode}
        </span>

        <h1
          className="text-5xl md:text-7xl font-bold text-[#f7f3ea] leading-tight mb-6 max-w-4xl"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Cupping thérapie à {BRAND.city}
          <span className="block text-[#9fdcbe] italic text-[0.85em] mt-2">
            Douleurs, stress, récupération
          </span>
        </h1>

        <p className="text-lg md:text-xl text-[#f7f3ea]/80 max-w-2xl leading-relaxed mb-4">
          Cabinet {BRAND.name} — ventouses et soins naturels, en toute confiance.
          Consultation initiale <strong className="text-[#c9ecd9]">gratuite</strong>.
        </p>
        <p className="text-sm text-[#a8dcc4]/90 mb-10">{BRAND.teamLine}</p>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <a
            href={BOOKING_URL}
            className="inline-flex items-center gap-2 bg-[#0b6b52] hover:bg-[#0d7f61] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-base"
          >
            <i className="ri-calendar-check-line"></i>
            Demander un rendez-vous
          </a>
          <a
            href="#cupping"
            onClick={(e) => {
              e.preventDefault();
              handleNav('#cupping');
            }}
            className="inline-flex items-center gap-2 border border-[#f2ede2]/35 hover:bg-[#f2ede2]/10 text-[#f2ede2] font-semibold px-8 py-4 rounded-full backdrop-blur-sm transition-colors cursor-pointer whitespace-nowrap text-base"
          >
            <i className="ri-play-circle-line"></i>
            Découvrir nos soins
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[#f7f3ea]/50 animate-cue">
        <i className="ri-arrow-down-line text-xl"></i>
      </div>
    </section>
  );
}
